import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0196',
    ecrans: ['00-2'],
    params: ['id', '?prbcleint']
});
